import moment from 'moment';
import { useSelector } from 'react-redux';
import {
  chatWidgetTroubleshootingLastResultSelector,
  chatWidgetTroubleshootingLastResultTimeSelector,
} from '@mm/state/selectors/chatWidgetTroubleshootingSelectors';
import { Result } from '../ChatWidgetTroubleshootingToolResult';
import { useWhitelabelConfig } from '@mm/hooks/src/use-whitelabel-config';

type Props = {
  isXRay?: boolean;
};

export const useJSTimestampResult = (props: Props): Result => {
  const { isXRay } = props;
  const result = useSelector(chatWidgetTroubleshootingLastResultSelector);
  const resultTime = useSelector(
    chatWidgetTroubleshootingLastResultTimeSelector,
  );

  const { pixelName: whitelabelPixelName } = useWhitelabelConfig();
  const pixelName = whitelabelPixelName
    ? `${whitelabelPixelName} Lead Generator`
    : 'X-Ray Lead Generation Pixel';

  if (!result || !resultTime || !result.globalJS.loaded) {
    return;
  }

  const scriptOutdated =
    !result.globalJS.scriptTimestamp ||
    moment(result.globalJS.scriptTimestamp).isBefore(
      moment(resultTime).add(-5, 'minutes'),
    );

  if (scriptOutdated) {
    return {
      result: 'error',
      description: isXRay
        ? `${pixelName} is outdated`
        : `Chat widget script is outdated`,
      infoTooltip:
        'Please clear any caching on your website, and ensure that your website is using the Customers.ai-hosted script and not a copy',
    };
  }
  return {
    result: 'ok',
    description: isXRay
      ? `${pixelName} is up to date`
      : 'Chat widget script is up to date',
  };
};
